<template>
  <div class="user-balance-use-detail">
    <tr-list request="/BizMemberMemberFlow/List" ref="trList" :data="{Type: '余额'}">
      <template slot="list" slot-scope="props">
        <van-steps direction="vertical" :active="0">
          <van-step v-for="item in props.list" :key="item.Id" class="step-group-item">
            <div class="time">
              {{ item.CreateTimeStr }}
            </div>
            <div class="title">{{ item.Type }}</div>
            <div class="text">
              {{ item.Text }}
            </div>
          </van-step>
        </van-steps>
      </template>
    </tr-list>
  </div>
</template>

<script>
export default {
  name: 'userBalanceUseDetail',
  data() {
    return{}
  },
  methods: {},
}

</script>

<style scoped lang="less">
.user-balance-use-detail{
  .step-group-item{
    .time{
      font-size: 12px;
      background-color: rgba(246, 246, 246);
      color: rgba(174, 174, 174);
      border-radius: 10px;
      padding: 2px 15px;
    }
    .title{
      font-size: 14px!important;
      margin: 15px 0 10px 0;
      color: #333333;
    }
    .text{
      font-size: 14px;
      word-break: break-all;
      color: rgba(174, 174, 174);
      line-height: 20px;
      margin-bottom: 30px;
    }
  }
  ::v-deep.van-step__circle{
    width: 10px!important;
    height: 10px!important;
  }
}
</style>
